import {where} from "firebase/firestore";
import {contarSumaWhere} from "../../Servicios/BD/Contadores/contarSumaWhere";

export const obtenerTotalDepositos = async (idUsuario) => {



    let w = [where('idUsuario', '==', idUsuario), where('estado', '==', 'Aceptado'), where('tipo', '==', 'Deposito')];
    let dox = await contarSumaWhere({coleccion: 'movimientos', wheres: w, propiedad: 'valor'})



    if (dox.res) {
        return dox.data
    } else {
        return 0
    }


    //Falta restar los gastos ( compra contratos, pago de menbresia

}